export const fileManagerTableStyles = {
  rows: {
    style: {
      minHeight: "40px",
      "&:hover": {
        backgroundColor: "#e6d9ff",
        cursor: "pointer",
      },
    },
  },
  headCells: {
    style: {
      paddingLeft: "5px",
      paddingRight: "5px",
      paddingTop: "5px",
      paddingBottom: "5px",
      fontWeight: "600",
      fontSize: "14px",
      letterSpacing: "-0.02em",
    },
  },
  cells: {
    style: {
      paddingLeft: "5px",
      paddingRight: "5px",
      paddingTop: "5px",
      paddingBottom: "5px",
    },
  },
};
